import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


$('.logo-slider .swiper').each(function() {
	const el = $(this);
	const section = el.closest('.logo-slider');
	const isAutoplay = el.data('autoplay') === true;

	const config = {
		loop: true,
		loopAdditionalSlides: 4,
		slidesPerView: 2,
		spaceBetween: 20,
		breakpoints: {
			480: {
				slidesPerView: 3,
				spaceBetween: 20
			},
			640: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			780: {
				slidesPerView: 4,
				spaceBetween: 40
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 40
			}
		}
	};

	if (isAutoplay) {
		config.allowTouchMove = false;
		config.speed = 6000;
		config.loop = true;
	}

	const slider = new Swiper(this, config);

	if (isAutoplay) {
		const wrapperEl = slider.wrapperEl;
		wrapperEl.style.transitionTimingFunction = 'linear';
		let sliding = false;

		function continuousSlide() {
			if (sliding) return;
			sliding = true;
			slider.slideNext(6000);
		}

		slider.on('transitionEnd', function() {
			sliding = false;
			continuousSlide();
		});

		slider.on('resize', function() {
			sliding = false;
			wrapperEl.style.transitionTimingFunction = 'linear';
			continuousSlide();
		});

		continuousSlide();
	} else {
		el.siblings('.next').on('click', function(e) {
			e.preventDefault();
			slider.slideNext();
		});

		el.siblings('.prev').on('click', function(e) {
			e.preventDefault();
			slider.slidePrev();
		});
	}
});

